import {useAppSelector} from "@/store";
import {AuthState} from "@/store/slices/auth";

export const useAuthStore = (): AuthState => {
    return useAppSelector(state => state.auth)
}
